import { useEffect, useRef, useCallback } from 'react';
import { useParams, useSearchParams } from 'next/navigation';
import { getHostFromWindow } from '@qb/frontend/utils/hosts/getHostFromWindow';
import { UTM_SOURCE_QUERY_PARAM_KEY } from '@qb/httpRequest/constants';
import { spsClientQueries } from '@qb/httpRequest/spsClientQueries';
import { PageParams } from '@/global/types/types';
import { useRequestPartPriceFromSPW } from '@/hooks/useRequestPartPriceFromSPW';
export const useRecordPartView = (partID: number) => {
  const params = useParams<PageParams>();
  const searchParams = useSearchParams();
  const utmSource = searchParams?.get(UTM_SOURCE_QUERY_PARAM_KEY);
  const hasRunOnce = useRef(false);
  const {
    authUser
  } = useRequestPartPriceFromSPW();
  const callbackToRunOnce = useCallback(() => {
    if (params?.tenantAlias) {
      spsClientQueries.part.recordPartView(getHostFromWindow(), params.tenantAlias, partID, utmSource).mutationFn();
    }
  }, [params, partID, utmSource]);
  const isAuthUserReceived = typeof authUser !== 'undefined';
  const shouldRun = isAuthUserReceived && !!partID;
  useEffect(() => {
    if (shouldRun && !hasRunOnce.current) {
      callbackToRunOnce();
      hasRunOnce.current = true;
    }
  }, [shouldRun, callbackToRunOnce]);
};